<!--
  @Author: The Jin
  @Date: 2025-05-26 15:56
  @FilePath: src\views\sop\addEditPopup.vue
  @Description: 新建任务  编辑任务
  @LastEditors:  The Jin
  @LastEditTime: 2025-05-26
  @LastDescription: 
 -->

<template>
    <div>
        <el-dialog :title="titleName" @close="closeDialog" :visible.sync="dialogVisibleM" :modal-append-to-body="false"
            width="850px" height="504px" class="add-label-dialog" :close-on-click-modal="false">
            <div v-loading="loading">
                <el-form :model="formData" :rules="rules" ref="formRef" label-width="100px" class="demo-ruleForm"
                    style="overflow: auto;max-height: 55vh;">
                    <el-form-item label="任务名称" prop="msgName">
                        <el-input :disabled="currentPopupType == 'edit' || currentPopupType == 'details'" size="small"
                            v-model="formData.msgName" show-word-limit :maxlength="30" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="执行群聊" prop="chatType">
                        <el-radio-group :disabled="currentPopupType == 'edit' || currentPopupType == 'details'"
                            v-model="formData.chatType">
                            <el-radio :label="0">全部群聊</el-radio>
                            <el-radio :label="1">指定群聊</el-radio>
                        </el-radio-group>
                        <div v-if="formData.chatType == 1" style="display: flex;align-items: center;">
                            <el-button size="small" @click="openSelectQuPopup"
                                v-if="!(currentPopupType == 'edit' || currentPopupType == 'details')">+ 选择群聊</el-button>
                            <div v-if="formData.chatList && formData.chatList.length" style="margin-left:10px">
                                已选: {{ formData.chatList.length }}条
                            </div>
                            <el-button style="margin-left: 10px;"
                                v-if="formData.chatList && formData.chatList.length && !(currentPopupType == 'edit' || currentPopupType == 'details')"
                                type="warning" size="small" @click="clearSelected()">清空已选</el-button>
                        </div>
                        <div v-if="formData.chatType == 1 && formData.chatList && formData.chatList.length"
                            style="line-height: 26px; background-color: rgba(204, 204, 204, 0.12);padding:10px ; border-radius: 5px;">
                            {{ handleChartsName() }}
                        </div>
                    </el-form-item>
                    <el-form-item label="执行员工">
                        <span>群主</span>
                    </el-form-item>
                    <el-form-item label="推送规则" prop="pushType">
                        <el-radio-group :disabled="currentPopupType == 'edit' || currentPopupType == 'details'"
                            v-model="formData.pushType">
                            <el-radio :label="0">即时推送</el-radio>
                            <el-radio :label="1">周期推送</el-radio>
                        </el-radio-group>
                        <p v-if="formData.pushType == 0" class="tips-row">*即时推送：创建任务后，立即触发的一次性群发任务</p>
                        <div v-else-if="formData.pushType == 1">
                            <p class="tips-row">*周期推送：在一定时间范围内，每天指定时间推送群发任务。</p>
                            <div class="date-row" v-if="currentPopupType == 'edit'">
                                <div class="date-item">
                                    <span>开始日期：</span>
                                    <el-date-picker :disabled="true" v-model="formData.pushStartTime" size="mini"
                                        type="date" placeholder="选择日期">
                                    </el-date-picker>
                                </div>
                                <div class="date-item">
                                    <span>结束日期：</span>
                                    <el-date-picker :picker-options="disabledBeforeDate" v-model="formData.pushEndTime"
                                        size="mini" type="date" placeholder="选择日期" @change="changeRangEnd"
                                        format="yyyy-MM-dd ">
                                    </el-date-picker>
                                </div>
                            </div>
                            <div v-else>
                                <el-date-picker :disabled="currentPopupType == 'details'" @change="changeRang" size="small"
                                    v-model="pushTime" type="daterange" :picker-options="pickerOptions" range-separator="至"
                                    start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </div>
                            <div style="display: flex;align-items: center;"><span style="margin-right: 4px;">发送节点：每天</span>
                                <el-time-select style="width: 130px;" size="small" v-model="formData.pushNode"
                                    :picker-options="{
                                        start: '00:00',
                                        step: '00:30',
                                        end: '23:30'
                                    }" placeholder="选择时间">
                                </el-time-select>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <template slot="label">
                            <span style="color: #ff4b59;margin-right: 5px;transform: translate(0, 2px);">*</span>发送内容
                        </template>
                        <div class="task-detail">
                            <MyUpload ref="myUploadRef" :upLoadData="upLoadData" :myType="myType"
                                @receiveParam="receiveParam"
                                :onlyShow="(currentPopupType == 'edit' || currentPopupType == 'details') && formData.pushType == 0 ? true : false" />

                        </div>
                    </el-form-item>
                </el-form>
                <!-- {{ formData }} -->
                <div slot="footer" class="dialog-footer" style="display: flex;justify-content: flex-end;margin-top: 10px;">
                    <el-button size="small " @click="closeDialog" style="margin-right:20px">{{ currentPopupType != 'details'
                        ? '取 消' : '关 闭' }}</el-button>
                    <el-button v-if="currentPopupType != 'details'" type="primary" size="small" @click="confirmWeicome()">确
                        定</el-button>
                </div>
            </div>
        </el-dialog>
        <groupSelectPopup v-if="showGroupSelectPopup" :dialogVisible.sync="showGroupSelectPopup"
            @selectedData="selectedData" :disabledSelect="formData.chatList" />
    </div>
</template>
<script>
import groupSelectPopup from './groupSelectPopup.vue'
import MyUpload from "@/views/mass/SOP/components/myUpload.vue";
import {
    msgGroupDetailApi, createMsgSendApi, msgGroupSaveApi
} from "@/api/groupSop.js";
import dayjs from "dayjs";
export default {
    // 新建sop任务弹框
    name: "addEditPopup",
    components: {
        groupSelectPopup,
        MyUpload,
    },
    props: {
        titleName: {
            type: String,
            default: "",
        },
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        row: {
            type: Object,
            default: null,
        },
        currentPopupType: {
            type: String,
            default: null,
        },
        // 类型 1为新增好友sop，2为新增生日提醒sop，3为新增朋友圈sop，4为活码，5为群发  6话术库 7群sop
        myType: {
            type: Number,
            default: 7,
        },
    },
    data() {
        return {
            /**是否时编辑 */
            isEdit: false,
            formRef: null,
            dialogVisibleM: false,
            rules: {
                msgName: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
                ],
                chatType: [
                    { required: true, message: '请选择', trigger: 'change' },
                ],
                pushType: [
                    { required: true, message: '请选择', trigger: 'change' },
                ],
                content: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { min: 1, max: 500, message: '长度在 1 到 500 个字符', trigger: 'blur' }
                ],
            },
            formData: {
                id: null,
                msgName: "",
                /**群发类型 0 全部群聊 1指定群聊 */
                chatType: 1,
                /**指定群id */
                chatList: [],
                /**推送类型 0 即时推送 1 周期推送 */
                pushType: 0,

                /**推送开始时间*/
                pushStartTime: null,
                /**推送结束时间*/
                pushEndTime: null,
                pushNode: null,
                userList: [], // 员工列表
                content: "",
                /**照片 视频  文件*/
                resourceVos: [],
                /**链接 商品 */
                linkVo: {
                    linkType: "", // 类型   空为网页链接    goods为商品    coupon为券
                    title: "",
                    httpUrl: "",
                    content: "",
                    pictureUrl: "",
                    pictureName: "",
                    price: "", // 商品/券价格
                    couEnableprice: "", //券满可用金额
                },
            },
            pushTime: [],
            pickerOptions: {
                disabledDate(time) {
                    // 禁用过去的日期
                    return time.getTime() < Date.now() - 86400000; // 当前时间减一天，确保可以选择今天
                }
            },
            myUploadFlag: false,
            showGroupSelectPopup: false,
            loading: false,
            showMyUpload: false,
            myUploadRef: null,
            upLoadData: null,
            disabledBeforeDate: {
                disabledDate: (time) => {
                    // 将指定日期转换为时间戳
                    const specificDate = new Date(this.formData.pushStartTime).getTime();
                    // 将选择的时间转换为时间戳
                    const targetDate = new Date(time).getTime();
                    // 如果选择的时间大于或等于指定日期，则禁用该日期
                    return targetDate < specificDate ? true : false
                }
            }
        }
    },

    watch: {
        dialogVisible: {
            handler(newVal, oldVal) {
                console.log("监听 dialogVisible", newVal);
                this.dialogVisibleM = newVal
                if (newVal) {
                    // this.initFunc();
                }
            },
            deep: true,
            immediate: true,
        },
    },
    computed: {
    },
    mounted() {
        console.log('mounted', this.row);
        if (this.currentPopupType == 'edit') {
            if (!this.row.id) {
                return this.$message.warning('id不能为空');

            }
            this.getDetais()
            this.formData.id = this.row.id
        } if (this.currentPopupType == 'details') {
            if (!this.row.id) {
                return this.$message.warning('id不能为空');

            }
            this.getDetais()
            this.formData.id = this.row.id
        } else {
            this.showMyUpload = true
        }
    },
    methods: {
        /**编辑的时候 获取详情 */
        getDetais() {
            this.loading = true
            msgGroupDetailApi({ id: this.row.id }, localStorage.getItem("Authorization")).then(
                (res) => {
                    this.loading = false
                    if (res.error.code == 200) {
                        for (const key in res.data) {
                            if (Object.hasOwnProperty.call(res.data, key)) {
                                key in this.formData ? this.formData[key] = res.data[key] : ''
                            }
                        }

                        // this.formData["linkVo"] = { "pictureUrl": "https://mall-static.hmccloud.com/3/1/13e44a01/146d8a01/1724036624915.png", "price": 100, "title": "0102项目1测试名字长度测试名字长度测试名字长度测试名字长度测", "linkType": "goods", "httpUrl": "https://wxaurl.cn/N9QmwBv7XJb" }
                        // this.formData["linkVo"] ={"title":"新增链接","httpUrl":"https://wecom-callback.dev.hmsaas.cn/qwadmin/group/sop","content":"新增链接123","pictureUrl":"/wecom/wpHiy3CAAAJEpISih4OQ4Pw95UHKo8sg/2025/05/29/66d0e56b-7726-4cb2-832a-2285d55c24a9.png","pictureName":"55.png","fileFullUrl":"https://klb-1318632921.cos.ap-guangzhou.myqcloud.com/wecom/wpHiy3CAAAJEpISih4OQ4Pw95UHKo8sg/2025/05/29/66d0e56b-7726-4cb2-832a-2285d55c24a9.png"}
                        setTimeout(() => {
                            this.upLoadData = {
                                content: this.formData.content,
                                resourceVos: this.formData.resourceVos,
                                sopLink: this.formData.linkVo
                            }
                            this.showMyUpload = true
                        }, 10);
                    }
                }
            );
        },

        /**打开选择群聊弹出框 */
        openSelectQuPopup() {
            console.log('openSelectQuPopup');

            this.showGroupSelectPopup = true
        },
        /**选择日期范围 */
        changeRang(val) {
            if (val && val.length) {
                this.formData.pushStartTime = dayjs(val[0]).format(
                    "YYYY-MM-DD HH:mm:ss"
                );
                this.formData.pushEndTime =
                    dayjs(val[1]).format("YYYY-MM-DD") + " " + "23:59:59";



                // this.formData.pushStartTime = new Date(val[0] + " 00:00:00").getTime()
                // this.formData.pushEndTime = new Date(val[1] + " 00:00:00").getTime()

            }
        },
        /**编辑的时候 修改结束时间 */
        changeRangEnd(val) {
            console.log('changeRangEnd', val, 555, val ? (new Date(val)).getTime() : '');
            if (val) {
                this.formData.pushEndTime = dayjs(val).format(
                    "YYYY-MM-DD HH:mm:ss"
                )
                // this.formData.pushEndTime = new Date(val + " 00:00:00").getTime()

                // this.formData.pushStartTime = new Date(val[0] + " 00:00:00").getTime()
                // this.formData.pushEndTime = new Date(val[1] + " 00:00:00").getTime()
            }
            // else{
            //     this.formData.pushEndTime =null
            // }
        },
        /**关闭 */
        closeDialog(reset) {
            this.$emit('update:dialogVisible', false)
            if (reset) {
                this.$emit('getData')

            }
        },

        // 接受上传组件返回的参数
        receiveParam(obj) {
            console.log("接受上传组件返回的参数", obj);
            this.formData.content = obj?.content || null
            this.formData.linkVo = obj?.product || obj?.linkVo || null
            this.formData.resourceVos = obj?.resourceVos || []
            this.myUploadFlag = obj.flag;
        },

        // 选中指定群聊
        selectedData(obj) {
            console.log("选中指定群聊", obj);
            if (obj && obj.length) {
                obj.forEach(v => {
                    if (this.formData.chatList && this.formData.chatList.length) {
                        if (!(this.formData.chatList.some(j => { return j.chatId == v.chatId }))) {
                            this.formData.chatList.push(v)
                        }
                    } else {
                        this.formData.chatList.push(v)

                    }
                })
            }
        },

        handleChartsName() {
            let res = ''
            if (this.formData.chatList && this.formData.chatList.length) {
                this.formData.chatList.forEach(k => {
                    res += (res ? '，' : '') + k.chatName
                })
            }
            return res

        },
        /**清空已选指定的群聊 */
        clearSelected() {
            this.formData.chatList = []
            this.formData.chatList = []
        },


        /**确定 */
        confirmWeicome() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    // 非周期推送 清空对应的值
                    if (this.formData.pushType != 1) {
                        this.formData.pushStartTime = ''
                        this.formData.pushEndTime = ''
                        this.formData.pushNode = ''
                        this.pushTime = []
                    }
                    // 非指定群聊 清空对应的值
                    if (this.formData.chatType != 1) {
                        this.formData.chatList = []
                    }
                    // 校验指定群聊
                    if (this.formData.chatType == 1 && (!this.formData.chatList || (this.formData.chatList && !this.formData.chatList.length))) {
                        return this.$message.warning("指定群聊不能为空");
                    }
                    // 校验周期推送
                    if (this.formData.pushType == 1 && (!this.formData.pushStartTime || !this.formData.pushEndTime
                        || !this.formData.pushNode)) {
                        return this.$message.warning("周期推送时间不能为空");
                    }
                    // 校验内容
                    if (!this.myUploadFlag) {
                        return this.$message.warning("发送内容不能为空");
                    }
                    console.log('submit', this.formData, this.row);
                    this.loading = true
                    if (this.row) {
                        msgGroupSaveApi(this.formData, localStorage.getItem("Authorization")).then(
                            (res) => {
                                this.loading = false
                                if (res.error.code == 200) {
                                    this.$message.success("保存成功!");
                                    this.closeDialog(true);
                                }
                            }).catch(() => {
                                this.loading = false
                            });
                    } else {
                        createMsgSendApi(this.formData, localStorage.getItem("Authorization")).then(
                            (res) => {
                                this.loading = false
                                if (res.error.code == 200) {
                                    this.$message.success("新建成功!");
                                    this.closeDialog(true);
                                }
                            }).catch(() => {
                                this.loading = false
                            });
                    }
                } else {
                    console.log('error submit!!', this.formData,);
                    return false;
                }
            });


        }
    },
};
</script>
<style lang="scss" scoped>
.tips-row {
    height: 10px;
    line-height: 10px;
    color: #409eff;
    margin-top: 0 !important;
    margin-bottom: 20px;
    font-size: 12px；
}

.task-detail {
    padding: 0 11px;
    font-size: 12px;

    .detial-item {
        display: flex;
        align-items: center;
        margin-bottom: 16px;

        .label {
            margin-right: 15px;
            font-size: 14px;
            font-weight: bold;
        }

        .icon-style {
            margin-left: 12px;
        }
    }

    /deep/.number-input {
        margin: 0 4px;

        .el-input__inner {
            padding: 0 4px 0 15px;
        }
    }
}

.date-row {
    display: flex;
    flex-direction: column;
}
</style>
  